// Name validator - allows letters, numbers, and single spaces between words
export const nameRegex = /^[A-Za-z0-9]+( [A-Za-z0-9]+)*$/;

// Email validator
export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

// Password validators
export const passRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[#?!@$%^&*-])\S{8,}$/;
export const digitsRegExp = /\d/;
export const lowercaseRegExp = /[a-z]/;
export const uppercaseRegExp = /[A-Z]/;
export const specialCharRegExp = /[#?!@$%^&*-]/;
/* // export const lowercaseRegExp = /(?=[^a-z]*[a-z])/;
// export const uppercaseRegExp = /(?=[^A-Z]*[A-Z])/;
// export const specialCharRegExp = /(?=[^#?!@$%^&*-]*[#?!@$%^&*-])/; */

// Allows only digits, or an optional +1 prefix.
// First digit (after +1 if present) cannot be 0.
export const phoneRegex = /^(?:\+1\s?)?(?:\([1-9]\d{2}\)|[1-9]\d{2})[-.\s]?\d{3}[-.\s]?\d{4}$/;
export const urlRegex = /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,63}){1,}(:\d+)?(\/[^\s]*)?$/i;
